module.exports = __webpack_public_path__ + "img/issue-icon.de38a544.svg";